import { Component, OnInit } from '@angular/core';
import { UtilService } from '../shared/service/util/util.service';
import { RelatoriosService } from '../shared/service/relatorios/relatorios.service';
import { LoginService } from '../shared/service/login/login.service';
import { Relatorio, saveFile } from '../shared';
import { CertificadoComunicacaoService } from '../shared/service/certificado-comunicacao/certificado-comunicacao.service';
import { CertificadoComunicacao } from '../shared/model/certificadoComunicacao';

@Component({
    selector: 'app-relatorio',
    templateUrl: './relatorio.component.html',
    styleUrls: ['./relatorio.component.css'],
})
export class RelatorioComponent implements OnInit {

    showSpinner: boolean = false;
    selectedTipoRelatorio: string;
    selectedStatusUsuario: string;
    relatorio: Relatorio = new Relatorio();
    certificadosComunicacao: CertificadoComunicacao[] = [];
    idCertificadoComunicacao: string;

    constructor(
        private loginService: LoginService,
        private utilService: UtilService,
        private certificadoComunicacaoService: CertificadoComunicacaoService,
        private relatoriosService: RelatoriosService) {

    }

    ngOnInit() {
        this.showSpinner = true;
        this.selectedTipoRelatorio = "";
        this.selectedStatusUsuario = "";
        this.listarCertificadosComunicacao();
    }

    validarPeriodo() : boolean {
        let dataValidas = true;
        
        if ((this.relatorio.dataInicio && !this.relatorio.dataFim) || (!this.relatorio.dataInicio && this.relatorio.dataFim)) {
            this.utilService.showError("Informe a Data Inicial e a Data Final para a consulta");
            dataValidas = false;
        } else {
            if (this.relatorio.dataInicio && this.relatorio.dataFim) {
                const nmDtInicio: number = new Date(this.relatorio.dataInicio).getTime();
                const nmDtFim: number = new Date(this.relatorio.dataFim).getTime();
    
                if (nmDtInicio > nmDtFim) {
                    this.utilService.showError("A Data Inicial não pode ser maior que Data Final");
                    dataValidas = false;
                }
            }
        }  
        return dataValidas;
    }

    lowerCase(email: string) {
        if (email !== undefined) {
            this.relatorio.email = email.toLowerCase();
        }
    }

    upperCase(nome: string) {
        if (nome !== undefined) {
            this.relatorio.nome = nome.toUpperCase();
        }
    }

    limpar() {
        this.relatorio = new Relatorio();
        this.selectedStatusUsuario = "";
        this.idCertificadoComunicacao = this.certificadosComunicacao[0].id.toString();
    }

    listarCertificadosComunicacao() {
        let organizacaoId = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;

        this.certificadoComunicacaoService.listar(organizacaoId).then(
            (request) => {
                this.showSpinner = false;
                this.certificadosComunicacao = request;
                this.idCertificadoComunicacao = this.certificadosComunicacao[0].id.toString();
            }).catch((err) => {
                this.showSpinner = false;
                if (err.status === 401 || err.status === 403) {
                    this.loginService.logout();
                } else {
                    this.utilService.showError(err);
                }
            });
    }

    gerarRelatorios() {
        if (this.selectedTipoRelatorio == "1") {
            this.gerarRelatorioCadastroUsuarios();
        } else if (this.selectedTipoRelatorio == "2") {
            this.gerarRelatorioMetricas();
        } else if (this.selectedTipoRelatorio == "3") {
            this.gerarRelatorioSolicitacoes();
        } else if (this.selectedTipoRelatorio == "4") {
            this.gerarRelatorioLicencasConsumidas();
        }
    }

    getRelatorio() : boolean {
        let dataValidas = this.validarPeriodo();

        if (dataValidas) {        
            this.showSpinner = true;
            this.relatorio.idOrganizacao = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;

            if (this.selectedStatusUsuario == "1") {
                this.relatorio.ativo = true;
                this.relatorio.excluido = false;
                this.relatorio.pendente = false;
            } else if (this.selectedStatusUsuario == "2") {
                this.relatorio.ativo = false;
                this.relatorio.excluido = false;
                this.relatorio.pendente = false;
            } else if (this.selectedStatusUsuario == "3") {
                this.relatorio.ativo = null;
                this.relatorio.excluido = true;
                this.relatorio.pendente = null;
            } else if (this.selectedStatusUsuario == "4") {
                this.relatorio.ativo = false;
                this.relatorio.excluido = false;
                this.relatorio.pendente = true;
            } else {
                this.relatorio.ativo = null;
                this.relatorio.excluido = null;
                this.relatorio.pendente = null;
            }
        }
        return dataValidas;     
    }

    gerarRelatorioCadastroUsuarios() {
        if (!this.getRelatorio()) {
            return;
        }

        this.relatoriosService.relatorioCadastroUsuarios(this.relatorio).
            then((request) => {
                this.showSpinner = false;
                if (request.body.size > 0) {
                    saveFile(request.body as Blob, "relatorio_cadastro_usuario.xls");
                } else {
                    this.utilService.showError("A consulta não retornou dados");
                }
            }).catch(error => {
                this.showSpinner = false;
                if (error.status === 401 || error.status === 403) {
                    this.loginService.logout();
                } else {
                    this.utilService.showError(error.message);
                }
            });
    }

    gerarRelatorioMetricas() {
        if (!this.getRelatorio()) {
            return;
        }

        this.relatoriosService.relatorioMetricas(this.relatorio).
            then((request) => {
                this.showSpinner = false;
                if (request.body.size > 0) {
                    saveFile(request.body as Blob, "relatorio_metricas.xls");
                } else {
                    this.utilService.showError("A consulta não retornou dados");
                }
            }).catch(error => {
                this.showSpinner = false;
                if (error.status === 401 || error.status === 403) {
                    this.loginService.logout();
                } else {
                    this.utilService.showError(error.message);
                }
            });
    }

    gerarRelatorioSolicitacoes() {
        if (!this.getRelatorio()) {
            return;
        }

        this.relatoriosService.relatorioSolicitacoes(this.relatorio).
            then((request) => {
                this.showSpinner = false;
                if (request.body.size > 0) {
                    saveFile(request.body as Blob, "relatorio_solicitacoes.xls");
                } else {
                    this.utilService.showError("A consulta não retornou dados");
                }
            }).catch(error => {
                this.showSpinner = false;
                if (error.status === 401 || error.status === 403) {
                    this.loginService.logout();
                } else {
                    this.utilService.showError(error.message);
                }
            });
    }

    gerarRelatorioLicencasConsumidas() {
        this.showSpinner = true;
        this.relatorio.idCertificadoComunicacao = Number(this.idCertificadoComunicacao);

        this.relatoriosService.relatorioLicencasConsumidas(this.relatorio).
            then((request) => {
                this.showSpinner = false;
                if (request.body.size > 0) {
                    saveFile(request.body as Blob, "relatorio_licencas_consumidas.xls");
                } else {
                    this.utilService.showError("A consulta não retornou dados");
                }
            }).catch(error => {
                this.showSpinner = false;
                if (error.status === 401 || error.status === 403) {
                    this.loginService.logout();
                } else {
                    this.utilService.showError(error);
                }
            });
    }
}
